export default function duree (type) {
    if ("JOUR" === type) {
        return "Jour"
    } else if ("MOIS" === type) {
        return "Mois"
    } else if ("ANNEE" === type) {
        return "Année";
    }
    return null;
}
